module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS2.294bb3a3.jpg";